import React, { useState } from "react";
import ContactForm from "./contactForm";
import Modal from "react-modal";

const Footer = () => {
  const [showPDF, setShowPDF] = useState(false);

  const handleOpenPDF = () => setShowPDF(true);
  const handleClosePDF = () => setShowPDF(false);

  const [ModalContactIsopen, setModalCOntactisOpen] = useState(false);

  return (
    <div>
      <div className="containFooter">
        <div className="topFooter">
          <div className="logoFooter">
            <img alt="undefined" src="/img/logo.png" />
          </div>
          <div className="linkFooter">
            <ul>
              <li onClick={handleOpenPDF} style={{ cursor: "pointer" }}>
                Conditions générales
              </li>
              <li
                onClick={() => setModalCOntactisOpen(true)}
                style={{ cursor: "pointer" }}
              >
                Contact
              </li>
            </ul>
          </div>
        </div>
        <div className="bottomFooter">
          <span>
            Copyright 2025, All rights reserved by PictureCommunication
          </span>
        </div>
      </div>
      <Modal
        isOpen={ModalContactIsopen}
        onRequestClose={() => setModalCOntactisOpen(false)}
        style={customStyles}
      >
        <button onClick={() => setModalCOntactisOpen(false)}>Fermer</button>
        <ContactForm />
      </Modal>
      {showPDF && (
        <div className="modalOverlay">
          <div className="modalContent">
            <button onClick={handleClosePDF} className="closeButton">
              ✕
            </button>
            <iframe
              src="/pdf/conditions.pdf"
              title="Conditions générales"
              className="iframe"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "2rem",
    borderRadius: "10px",
  },
};

export default Footer;
